import { jsx as o, Fragment as l, jsxs as m } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { getComponent as a, getEnableFallbackComponent as c, getCustomFallbackComponent as d } from "../core/state.mjs";
const s = i(
  ({ blok: e, ...r }, p) => {
    if (!e)
      return console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      ), /* @__PURE__ */ o("div", { children: "Please provide a blok property to the StoryblokServerComponent" });
    const t = a(e.component);
    if (t)
      return /* @__PURE__ */ o(t, { ref: p, blok: e, ...r });
    if (c()) {
      const n = d();
      return n ? /* @__PURE__ */ o(n, { blok: e, ...r }) : /* @__PURE__ */ o(l, { children: /* @__PURE__ */ m("p", { children: [
        "Component could not be found for blok",
        " ",
        /* @__PURE__ */ o("strong", { children: e.component }),
        "! Is it configured correctly?"
      ] }) });
    }
    return /* @__PURE__ */ o("div", {});
  }
);
s.displayName = "StoryblokServerComponent";
export {
  s as default
};
